import React, { useState } from "react";

//UI Material
import { Box, Grid, Tab, Tabs } from "@mui/material";

//Helpers
import { typographyForText } from "../Helpers/typography";

//Local components
import MySpace from "../Components/tasks-page/MySpace";
import AdministratorSpace from "../Components/tasks-page/AdministratorSpace";

//Function to generate tabs
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tasks-tabpanel-${index}`}
      aria-labelledby={`tasks-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{typographyForText(children)}</Box>}
    </div>
  );
}

export default function Tasks() {
  // ==========>Component States<==========
  // State for tab value
  const [tabValue, setTabValue] = useState(0);

  // ==========> Component Functions <==========
  //Function to set tab value
  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
  };
  //Function for giving an index to each tab
  function a11yProps(index) {
    return {
      id: `tasks-tab-${index}`,
      "aria-controls": `tasks-tabpanel-${index}`,
    };
  }

  // ==========> Component <==========
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Box>
          <Tabs
            centered
            indicatorColor="secondary"
            textColor="secondary"
            value={tabValue}
            onChange={handleChange}
            aria-label="tasks-tabs"
          >
            <Tab
              label="Mi espacio"
              sx={{ fontSize: "11px" }}
              {...a11yProps(0)}
            />
            <Tab
              label="Tareas del equipo"
              sx={{ fontSize: "11px" }}
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <TabPanel value={tabValue} index={0}>
          <MySpace />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <AdministratorSpace />
        </TabPanel>
      </Grid>
    </Grid>
  );
}
